const keyType = {
  CPF: 'CPF',
  CNPJ: 'CNPJ',
  TELEFONE: 'TELEFONE',
  EMAIL: 'EMAIL',
  CHAVE_ALEATORIA: 'CHAVE_ALEATORIA'
};

module.exports = keyType;
